import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const Hero = () => {
  const heroRef = useRef(null);
  const { scrollY } = useScroll();

  // Параллакс для круга - медленнее
  const circleScale = useTransform(scrollY, [0, 1200], [1, 2.5]);
  const circleOpacity = useTransform(scrollY, [0, 1200], [1, 0.3]);

  // Девушка - медленнее
  const girlY = useTransform(scrollY, [0, 1200], [0, -50]);

  // Opacity для всех иконок - очень плавное исчезновение
  const iconsOpacity = useTransform(scrollY, [0, 1000], [1, 0]);

  // ===== WB — 45° влево-вверх ↖ =====
  const leftIcon1X = useTransform(scrollY, [0, 1000], [0, -800]);
  const leftIcon1Y = useTransform(scrollY, [0, 1000], [0, -800]);
  const leftIcon1Rotate = useTransform(scrollY, [0, 1000], [0, -25]);

  // ===== OZON — 20° влево-вверх ↖ (положе) =====
  const leftIcon2X = useTransform(scrollY, [0, 1000], [0, -900]);
  const leftIcon2Y = useTransform(scrollY, [0, 1000], [0, -350]);
  const leftIcon2Rotate = useTransform(scrollY, [0, 1000], [0, -20]);

  // ===== Яндекс Маркет — 5° влево ← (почти горизонтально) =====
  const leftIcon3X = useTransform(scrollY, [0, 1000], [0, -950]);
  const leftIcon3Y = useTransform(scrollY, [0, 1000], [0, -80]);
  const leftIcon3Rotate = useTransform(scrollY, [0, 1000], [0, -15]);

  // ===== AliExpress — 45° вправо-вверх ↗ =====
  const rightIcon1X = useTransform(scrollY, [0, 1000], [0, 800]);
  const rightIcon1Y = useTransform(scrollY, [0, 1000], [0, -800]);
  const rightIcon1Rotate = useTransform(scrollY, [0, 1000], [0, 25]);

  // ===== МегаМаркет — 20° вправо-вверх ↗ (положе) =====
  const rightIcon2X = useTransform(scrollY, [0, 1000], [0, 900]);
  const rightIcon2Y = useTransform(scrollY, [0, 1000], [0, -350]);
  const rightIcon2Rotate = useTransform(scrollY, [0, 1000], [0, 20]);

  // ===== Авито — 5° вправо → (почти горизонтально) =====
  const rightIcon3X = useTransform(scrollY, [0, 1000], [0, 950]);
  const rightIcon3Y = useTransform(scrollY, [0, 1000], [0, -80]);
  const rightIcon3Rotate = useTransform(scrollY, [0, 1000], [0, 15]);

  const leftMarketplaces = [
    { name: 'Wildberries', icon: '/images/marketplaces/wb.png' },
    { name: 'Ozon', icon: '/images/marketplaces/Ozon.webp' },
    { name: 'Яндекс Маркет', icon: '/images/marketplaces/Yandex.webp' },
  ];

  const rightMarketplaces = [
    { name: 'AliExpress', icon: '/images/marketplaces/alie.webp' },
    { name: 'СберМегаМаркет', icon: '/images/marketplaces/megamarket.webp' },
    { name: 'Авито', icon: '/images/marketplaces/avito.webp' },
  ];

  const styles = {
    hero: {
      background: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: 'clamp(70px, 6vw, 100px)',
      paddingBottom: '0',
      position: 'relative',
      overflow: 'hidden',
    },
    scaleWrapper: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    // Декоративные блики
    glow1: {
      position: 'absolute',
      top: '10%',
      left: '5%',
      width: '300px',
      height: '300px',
      background: 'radial-gradient(circle, rgba(34, 211, 238, 0.15) 0%, transparent 70%)',
      filter: 'blur(40px)',
      pointerEvents: 'none',
    },
    glow2: {
      position: 'absolute',
      top: '20%',
      right: '8%',
      width: '250px',
      height: '250px',
      background: 'radial-gradient(circle, rgba(236, 72, 153, 0.12) 0%, transparent 70%)',
      filter: 'blur(40px)',
      pointerEvents: 'none',
    },
    glow3: {
      position: 'absolute',
      bottom: '15%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '280px',
      height: '280px',
      background: 'radial-gradient(circle, rgba(251, 191, 36, 0.1) 0%, transparent 70%)',
      filter: 'blur(40px)',
      pointerEvents: 'none',
    },
    eyebrow: {
      fontSize: '14px',
      fontWeight: 600,
      color: '#8B5CF6',
      textTransform: 'uppercase',
      letterSpacing: '3px',
      marginBottom: '20px',
    },
    title: {
      fontSize: 'clamp(28px, 4.5vw, 84px)',
      fontWeight: 800,
      color: '#0F0F1A',
      textAlign: 'center',
      lineHeight: 1.05,
      textTransform: 'uppercase',
      letterSpacing: '-1px',
      marginBottom: 0,
      marginTop: 0,
      position: 'relative',
      zIndex: 1,
    },
    titleGradient: {
      background: 'linear-gradient(90deg, #22D3EE 0%, #8B5CF6 50%, #EC4899 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    visualBlock: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      marginTop: 'clamp(10px, 1.5vw, 30px)',
      marginBottom: 0,
      height: 'clamp(320px, 38vw, 600px)',
    },
    circle: {
      position: 'absolute',
      width: 'clamp(220px, 30vw, 500px)',
      height: 'clamp(220px, 30vw, 500px)',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, rgba(34, 211, 238, 0.3) 0%, rgba(139, 92, 246, 0.25) 35%, rgba(236, 72, 153, 0.25) 65%, rgba(251, 191, 36, 0.3) 100%)',
      filter: 'blur(40px)',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
    },
    girl: {
      position: 'relative',
      zIndex: 10,
      height: 'clamp(360px, 44vw, 700px)',
      width: 'auto',
      objectFit: 'contain',
      marginTop: 0,
      marginBottom: 'clamp(-100px, -4vw, -10px)',
      filter: 'drop-shadow(0 30px 60px rgba(15, 15, 26, 0.15))',
      willChange: 'transform',
      backfaceVisibility: 'hidden',
    },
    // Левые иконки - индивидуальные позиции по дуге
    leftIcon1Style: {
      position: 'absolute',
      left: 'calc(50% - 300px)',
      top: 'calc(45% - 50px)',
      width: 'clamp(44px, 5vw, 80px)',
      height: 'clamp(44px, 5vw, 80px)',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(15, 15, 26, 0.1)',
      overflow: 'hidden',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
      transform: 'translateZ(0)',
      zIndex: 5,
    },
    leftIcon2Style: {
      position: 'absolute',
      left: 'calc(50% - 340px)',
      top: 'calc(45% + 40px)',
      width: 'clamp(44px, 5vw, 80px)',
      height: 'clamp(44px, 5vw, 80px)',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(15, 15, 26, 0.1)',
      overflow: 'hidden',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
      transform: 'translateZ(0)',
      zIndex: 5,
    },
    leftIcon3Style: {
      position: 'absolute',
      left: 'calc(50% - 300px)',
      top: 'calc(45% + 130px)',
      width: 'clamp(44px, 5vw, 80px)',
      height: 'clamp(44px, 5vw, 80px)',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(15, 15, 26, 0.1)',
      overflow: 'hidden',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
      transform: 'translateZ(0)',
      zIndex: 5,
    },
    // Правые иконки - индивидуальные позиции по дуге
    rightIcon1Style: {
      position: 'absolute',
      right: 'calc(50% - 300px)',
      top: 'calc(45% - 50px)',
      width: 'clamp(44px, 5vw, 80px)',
      height: 'clamp(44px, 5vw, 80px)',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(15, 15, 26, 0.1)',
      overflow: 'hidden',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
      transform: 'translateZ(0)',
      zIndex: 5,
    },
    rightIcon2Style: {
      position: 'absolute',
      right: 'calc(50% - 340px)',
      top: 'calc(45% + 40px)',
      width: 'clamp(44px, 5vw, 80px)',
      height: 'clamp(44px, 5vw, 80px)',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(15, 15, 26, 0.1)',
      overflow: 'hidden',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
      transform: 'translateZ(0)',
      zIndex: 5,
    },
    rightIcon3Style: {
      position: 'absolute',
      right: 'calc(50% - 300px)',
      top: 'calc(45% + 130px)',
      width: 'clamp(44px, 5vw, 80px)',
      height: 'clamp(44px, 5vw, 80px)',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(15, 15, 26, 0.1)',
      overflow: 'hidden',
      willChange: 'transform, opacity',
      backfaceVisibility: 'hidden',
      transform: 'translateZ(0)',
      zIndex: 5,
    },
    marketplaceImg: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    offerCard: {
      background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(236, 72, 153, 0.06) 100%)',
      border: '1px solid rgba(139, 92, 246, 0.15)',
      borderRadius: '20px',
      padding: '28px 40px',
      textAlign: 'center',
      marginTop: '-120px',
      marginBottom: '0',
      maxWidth: '700px',
    },
    offerTitle: {
      fontSize: '24px',
      fontWeight: 800,
      color: '#0F0F1A',
      marginBottom: '12px',
    },
    offerSubtitle: {
      fontSize: '16px',
      color: 'rgba(15, 15, 26, 0.6)',
      marginBottom: '24px',
      lineHeight: 1.5,
    },
    ctaButton: {
      padding: '16px 40px',
      borderRadius: '14px',
      border: 'none',
      background: 'linear-gradient(135deg, #22D3EE 0%, #8B5CF6 35%, #EC4899 65%, #FBBF24 100%)',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 700,
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s',
      boxShadow: '0 8px 24px rgba(139, 92, 246, 0.35)',
    },
    badges: {
      display: 'flex',
      gap: '20px',
      flexWrap: 'wrap',
      justifyContent: 'center',
      maxWidth: '1000px',
      marginTop: '20px',
      marginBottom: '0',
      paddingBottom: '0',
    },
    badge: {
      background: '#FFFFFF',
      borderRadius: '14px',
      padding: '16px 24px',
      boxShadow: '0 4px 16px rgba(15, 15, 26, 0.06)',
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      minWidth: '280px',
    },
    badgeTitle: {
      fontSize: '12px',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
    },
    badgeText: {
      fontSize: '14px',
      color: 'rgba(15, 15, 26, 0.6)',
      fontWeight: 500,
    },
    // Блок цитаты
    quoteBlock: {
      position: 'absolute',
      left: 'calc(10% + 100px)',
      top: 'calc(35% - 120px)',
      zIndex: 15,
      maxWidth: '360px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
    },
    quoteIcon: {
      width: '40px',
      height: 'auto',
      flexShrink: 0,
    },
    quoteCard: {
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderRadius: '16px',
      padding: '10px 12px',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
    },
    quoteText: {
      fontSize: '13px',
      lineHeight: 1.5,
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      margin: 0,
      opacity: 0.6,
    },
    // Блок гарантии справа
    guaranteeBlock: {
      position: 'absolute',
      right: '450px',
      top: 'calc(35% - 120px)',
      zIndex: 15,
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderRadius: '16px',
      padding: '10px 12px',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
      maxWidth: '200px',
    },
    guaranteeTitle: {
      fontSize: '20px',
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      marginBottom: '8px',
    },
    guaranteeText: {
      fontSize: '13px',
      lineHeight: 1.5,
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      margin: 0,
      opacity: 0.6,
    },
    // Блок "Под ключ" рядом с гарантией
    turnkeyBlock: {
      position: 'absolute',
      right: '304px',
      top: 'calc(35% - 120px)',
      zIndex: 15,
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderRadius: '16px',
      padding: '10px 12px',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
      maxWidth: '200px',
    },
    turnkeyTitle: {
      fontSize: '20px',
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      marginBottom: '8px',
    },
    turnkeyText: {
      fontSize: '13px',
      lineHeight: 1.5,
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      margin: 0,
      opacity: 0.6,
    },
    // Блок "Без рисков" под блоком "Под ключ"
    noRisksBlock: {
      position: 'absolute',
      right: '304px',
      top: 'calc(35% - 25px)',
      zIndex: 15,
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderRadius: '16px',
      padding: '10px 12px',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
      maxWidth: '200px',
    },
    noRisksTitle: {
      fontSize: '20px',
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      marginBottom: '8px',
    },
    noRisksText: {
      fontSize: '13px',
      lineHeight: 1.5,
      fontWeight: 500,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      margin: 0,
      opacity: 0.6,
    },
    // CTA блок
    ctaBlock: {
      position: 'absolute',
      bottom: '20%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
      background: 'rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderRadius: '24px',
      padding: '5px',
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.12)',
      maxWidth: '800px',
    },
    ctaIconImage: {
      width: '32px',
      height: '32px',
    },
    ctaTextContent: {
      fontSize: '11px',
      fontWeight: 400,
      lineHeight: 1.5,
      color: '#0F0F1A',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      margin: 0,
    },
    ctaButtonStyle: {
      background: 'linear-gradient(135deg, #7DD3FC 0%, #A78BFA 35%, #F472B6 65%, #FCD34D 100%)',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 700,
      textTransform: 'uppercase',
      padding: '15px',
      borderRadius: '24px',
      border: 'none',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      transition: 'transform 0.2s, box-shadow 0.2s',
    },
  };

  return (
    <section ref={heroRef} style={styles.hero} className="hero-section">
      <style>{`
        /* Позиции иконок маркетплейсов по дуге — масштабируются через vw */
        .hero-left-1 { left: calc(50% - clamp(170px, 22vw, 340px)) !important; top: calc(45% - clamp(30px, 4vw, 60px)) !important; }
        .hero-left-2 { left: calc(50% - clamp(190px, 25vw, 380px)) !important; top: calc(45% + clamp(20px, 3vw, 50px)) !important; }
        .hero-left-3 { left: calc(50% - clamp(170px, 22vw, 340px)) !important; top: calc(45% + clamp(80px, 10vw, 150px)) !important; }
        .hero-right-1 { right: calc(50% - clamp(170px, 22vw, 340px)) !important; top: calc(45% - clamp(30px, 4vw, 60px)) !important; }
        .hero-right-2 { right: calc(50% - clamp(190px, 25vw, 380px)) !important; top: calc(45% + clamp(20px, 3vw, 50px)) !important; }
        .hero-right-3 { right: calc(50% - clamp(170px, 22vw, 340px)) !important; top: calc(45% + clamp(80px, 10vw, 150px)) !important; }

        /* Tablet — скрываем инфо-блоки */
        @media (max-width: 1024px) {
          .hero-section { padding-top: 70px !important; }
          .hero-quote-block { display: none !important; }
          .hero-guarantee-block { display: none !important; }
          .hero-turnkey-block { display: none !important; }
          .hero-norisks-block { display: none !important; }
          .hero-cta-block { max-width: 600px !important; }
        }
        /* Mobile — вертикальный CTA */
        @media (max-width: 768px) {
          .hero-section { padding-top: 50px !important; }
          .hero-title { letter-spacing: -0.5px !important; }
          .hero-cta-block {
            flex-direction: column !important;
            max-width: 90vw !important;
            padding: 12px !important;
            gap: 10px !important;
            bottom: 10% !important;
            border-radius: 16px !important;
          }
          .hero-cta-block p { text-align: center !important; font-size: 10px !important; }
          .hero-cta-btn { font-size: 14px !important; padding: 12px 20px !important; border-radius: 14px !important; }
          .hero-cta-icon { display: none !important; }
          .hero-glow { width: 150px !important; height: 150px !important; }
        }
        @media (max-width: 480px) {
          .hero-cta-block { bottom: 5% !important; }
          .hero-cta-btn { font-size: 13px !important; padding: 10px 16px !important; }
        }
      `}</style>
      <div style={styles.scaleWrapper} className="hero-scale-wrapper">
        {/* Декоративные блики */}
        <div style={styles.glow1} className="hero-glow" />
        <div style={styles.glow2} className="hero-glow" />
        <div style={styles.glow3} className="hero-glow" />

        {/* Заголовок - три строки uppercase */}
        <h1 style={styles.title} className="hero-title">
          ПРОДВИЖЕНИЕ<br />
          ВАШЕГО БИЗНЕСА НА<br />
          <span style={styles.titleGradient}>OZON И WILDBERRIES</span>
        </h1>

        {/* Визуальный блок */}
        <div style={styles.visualBlock} className="hero-visual">
        {/* Круг с параллаксом */}
        <motion.div
          style={{
            ...styles.circle,
            scale: circleScale,
            opacity: circleOpacity,
          }}
          className="hero-circle"
        />

        {/* Блок цитаты - НЕ анимируется */}
        <div style={styles.quoteBlock} className="hero-quote-block">
          <img
            src="/images/quote.webp"
            alt=""
            style={styles.quoteIcon}
          />
          <div style={styles.quoteCard}>
            <p style={styles.quoteText}>
              Агентство полного цикла по работе с маркетплейсами — от создания карточек товаров и рекламных материалов до сотрудничества с блогерами.
            </p>
          </div>
        </div>

        {/* Блок гарантии справа - НЕ анимируется */}
        <div style={styles.guaranteeBlock} className="hero-guarantee-block">
          <div style={styles.guaranteeTitle}>ГАРАНТИЯ</div>
          <p style={styles.guaranteeText}>
            По договору<br />
            или возврат
          </p>
        </div>

        {/* Блок "Под ключ" рядом - НЕ анимируется */}
        <div style={styles.turnkeyBlock} className="hero-turnkey-block">
          <div style={styles.turnkeyTitle}>ПОД КЛЮЧ</div>
          <p style={styles.turnkeyText}>
            Ведем магазин<br />
            полностью
          </p>
        </div>

        {/* Блок "Без рисков" под блоком "Под ключ" - НЕ анимируется */}
        <div style={styles.noRisksBlock} className="hero-norisks-block">
          <div style={styles.noRisksTitle}>БЕЗ РИСКОВ</div>
          <p style={styles.noRisksText}>
            Берем все риски<br />
            на себя
          </p>
        </div>

        {/* CTA блок - на уровне пояса девушки */}
        <div style={styles.ctaBlock} className="hero-cta-block">
          {/* Иконка */}
          <img src="/images/marketplaces/shopping-list.webp" alt="" style={styles.ctaIconImage} className="hero-cta-icon" />

          {/* Текст */}
          <p style={styles.ctaTextContent}>
            УВЕЛИЧЕНИЕ ПРИБЫЛИ В 3 РАЗА НА<br />
            WILDBERRIES, OZON, YANDEX<br />
            ЗА СЧЕТ УМЕНЬШЕНИЯ ДРР
          </p>

          {/* Кнопка - градиент как в хедере */}
          <button
            style={styles.ctaButtonStyle}
            className="hero-cta-btn"
            onClick={() => window.dispatchEvent(new Event('openModal'))}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 8px 24px rgba(249, 115, 22, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = 'none';
            }}
          >
            ПОЛУЧИТЬ →
          </button>
        </div>

        {/* Левые иконки - расположены по дуге */}
        {/* WB - верхняя левая */}
        <motion.div
          style={{
            ...styles.leftIcon1Style,
            x: leftIcon1X,
            y: leftIcon1Y,
            rotate: leftIcon1Rotate,
            opacity: iconsOpacity,
          }}
          className="hero-marketplace-icon hero-left-1"
        >
          <img
            src={leftMarketplaces[0].icon}
            alt={leftMarketplaces[0].name}
            style={styles.marketplaceImg}
          />
        </motion.div>

        {/* Ozon - центральная левая (дальше) */}
        <motion.div
          style={{
            ...styles.leftIcon2Style,
            x: leftIcon2X,
            y: leftIcon2Y,
            rotate: leftIcon2Rotate,
            opacity: iconsOpacity,
          }}
          className="hero-marketplace-icon hero-left-2"
        >
          <img
            src={leftMarketplaces[1].icon}
            alt={leftMarketplaces[1].name}
            style={styles.marketplaceImg}
          />
        </motion.div>

        {/* Яндекс - нижняя левая */}
        <motion.div
          style={{
            ...styles.leftIcon3Style,
            x: leftIcon3X,
            y: leftIcon3Y,
            rotate: leftIcon3Rotate,
            opacity: iconsOpacity,
          }}
          className="hero-marketplace-icon hero-left-3"
        >
          <img
            src={leftMarketplaces[2].icon}
            alt={leftMarketplaces[2].name}
            style={styles.marketplaceImg}
          />
        </motion.div>

        {/* Девушка - увеличена и поднята */}
        <motion.img
          src="/images/girl.webp"
          alt="Первый Селлер"
          fetchpriority="high"
          style={{
            ...styles.girl,
            y: girlY,
          }}
          className="hero-girl"
        />

        {/* Правые иконки - расположены по дуге */}
        {/* Ali - верхняя правая */}
        <motion.div
          style={{
            ...styles.rightIcon1Style,
            x: rightIcon1X,
            y: rightIcon1Y,
            rotate: rightIcon1Rotate,
            opacity: iconsOpacity,
          }}
          className="hero-marketplace-icon hero-right-1"
        >
          <img
            src={rightMarketplaces[0].icon}
            alt={rightMarketplaces[0].name}
            style={styles.marketplaceImg}
          />
        </motion.div>

        {/* Сбер - центральная правая (дальше) */}
        <motion.div
          style={{
            ...styles.rightIcon2Style,
            x: rightIcon2X,
            y: rightIcon2Y,
            rotate: rightIcon2Rotate,
            opacity: iconsOpacity,
          }}
          className="hero-marketplace-icon hero-right-2"
        >
          <img
            src={rightMarketplaces[1].icon}
            alt={rightMarketplaces[1].name}
            style={styles.marketplaceImg}
          />
        </motion.div>

        {/* Авито - нижняя правая */}
        <motion.div
          style={{
            ...styles.rightIcon3Style,
            x: rightIcon3X,
            y: rightIcon3Y,
            rotate: rightIcon3Rotate,
            opacity: iconsOpacity,
          }}
          className="hero-marketplace-icon hero-right-3"
        >
          <img
            src={rightMarketplaces[2].icon}
            alt={rightMarketplaces[2].name}
            style={styles.marketplaceImg}
          />
        </motion.div>
      </div>

      {/* Оффер-карточка */}
      {/* <div style={styles.offerCard}>
        <h2 style={styles.offerTitle}>🚀 УВЕЛИЧЕНИЕ ПРИБЫЛИ в 3 раза</h2>
        <p style={styles.offerSubtitle}>
          на Wildberries, Ozon, Яндекс Маркет за счёт уменьшения ДРР
        </p>
        <button
          style={styles.ctaButton}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 12px 32px rgba(139, 92, 246, 0.45)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 8px 24px rgba(139, 92, 246, 0.35)';
          }}
        >
          Получить предложение →
        </button>
      </div> */}

      {/* Badges */}
      {/* <div style={styles.badges}>
        <div style={styles.badge}>
          <div style={{ ...styles.badgeTitle, color: '#22D3EE' }}>ГАРАНТИЯ</div>
          <div style={styles.badgeText}>По договору или возврат</div>
        </div>
        <div style={styles.badge}>
          <div style={{ ...styles.badgeTitle, color: '#EC4899' }}>ПОД КЛЮЧ</div>
          <div style={styles.badgeText}>Ведём магазин полностью</div>
        </div>
        <div style={styles.badge}>
          <div style={{ ...styles.badgeTitle, color: '#8B5CF6' }}>6000+ МАГАЗИНОВ</div>
          <div style={styles.badgeText}>Запустили с 2020 года</div>
        </div>
      </div> */}
      </div>
    </section>
  );
};

export default Hero;
